"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsPositionOutsideOfRestrictedAreaPolygon = void 0;
const utils_1 = require("@daytrip/utils");
const class_validator_1 = require("class-validator");
let IsPositionOutsideOfRestrictedAreaPolygon = class IsPositionOutsideOfRestrictedAreaPolygon {
    validate(value, validationArguments) {
        const { restrictedAreaPolygon } = validationArguments.object;
        if (!restrictedAreaPolygon) {
            return true;
        }
        return !(0, utils_1.isGeoPointInGeoPolygon)(value, restrictedAreaPolygon.coordinates[0]);
    }
    defaultMessage() {
        return "Position must be located outside of restricted area polygon.";
    }
};
exports.IsPositionOutsideOfRestrictedAreaPolygon = IsPositionOutsideOfRestrictedAreaPolygon;
exports.IsPositionOutsideOfRestrictedAreaPolygon = IsPositionOutsideOfRestrictedAreaPolygon = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: "Is position outside of restricted area polygon" })
], IsPositionOutsideOfRestrictedAreaPolygon);
//# sourceMappingURL=IsPositionOutsideOfRestrictedAreaPolygon.js.map